var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreenViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85716 12.5715V11.4287H4.57157V9.14307H3.42871V12.5716L6.85716 12.5715Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4283 6.85728H12.5711V3.42871H9.14258V4.57157H11.4282L11.4283 6.85728Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57169 4.57157H6.85728V3.42871H3.42871V6.85728H4.57157L4.57169 4.57157Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.571 12.5714V9.14282H11.4282V11.4284H9.14258V12.5713L12.571 12.5714Z",
    fill: "#323232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71441 16H14.2858C15.3916 16 16 15.3916 16 14.2857V1.71429C16 0.608381 15.3916 0 14.2857 0H1.71429C0.608381 0 0 0.608381 0 1.71429V14.2857C0 15.3915 0.608381 15.9999 1.71429 15.9999L1.71441 16ZM1.71441 2.28571C1.71441 2.00161 2.00186 1.71416 2.28597 1.71416H13.7145C13.9986 1.71416 14.2861 2.00161 14.2861 2.28571V13.7143C14.2861 13.9984 13.9986 14.2858 13.7145 14.2858H2.28597C2.00187 14.2858 1.71441 13.9984 1.71441 13.7143V2.28571Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenViewIcon);
export default __webpack_public_path__ + "static/media/fullScreenViewIcon.391fcb25802fc22ae43a65f53880f451.svg";
export { ForwardRef as ReactComponent };